import { getApiInstance } from './api.helpers';
export const fetchMyAccountDetails = async ({ environment }) => {
    const response = await getApiInstance(environment).get('/v2/accounts/me');
    return response.data ?? null;
};
export const updateMyAccountDetails = async ({ environment, accountId, payload, }) => {
    const response = await getApiInstance(environment).put(`/v2/accounts/${accountId}`, payload);
    return response.data;
};
